// Word Wheel puzzles for Portuguese.
// letters: the seven tiles. words: common words to find (shown in the count). extra: other valid words, accepted as bonus.
// Checked against a spelling dictionary, so no word needs to be verified while playing.

export const WHEEL_PT = [
    {
        letters: 'dainldo',
        words: 'alô ando ano dado dali dando dano daí dia doida dona dão dói ido indo lado lida lidando lido linda lindo lino não olá onda',
        extra: 'adi adido adil ado aio anil dina dinda doa dol doía dândi ida ila inda ino ladino landi lao lia lidado lindão lio loa lona nado nai noa noda noia nola odiá íon',
    },
    {
        letters: 'soldtie',
        words: 'del delito delitos disto dito dois dos dose dói eis estilo ido isto lei leio leis leito lido liso los lote sei seio selo sido site sol tido tio',
        extra: 'deis deito deli dite ditos doei dol dote dotes délio dês edil edis edito elo elos esto ide ides idos ileso ilê isole iões ledo leitos leto lide lides lidos lio lis lise liste listo lito lotes lês ode odes ois oti otis sedo seto sie silo sio sito soe solte soltei solé telo teso tidos tios tiê toei tos tédio tês íleo ões',
    },
    {
        letters: 'anratcr',
        words: 'arca arcar cana canta cantar cara carta catar narra nata rara raça tara taça tranca trancar trará traça traçar',
        extra: 'acra anca anta anã arar ata atar cata nara rana rata tacar',
    },
    {
        letters: 'danamed',
        words: 'ama anda andam ande dada dama demanda mana manda mande mãe nada nem',
        extra: 'ada ade adem amena andem anã danem deda ema emana ena mada meada meda mena nadam nade ámen',
    },
    {
        letters: 'tidsuee',
        words: 'deste deu deus eis este estudei sede sei sete seu site suíte tese teu teus usei úteis',
        extra: 'deis deite dese detê dite diu dês edis edite estude ide ides sie situ situe suei sui tiê tês udi',
    },
    {
        letters: 'tenamed',
        words: 'ande ante atende atendem até dante deem dente detém emenda ente mande mantê mede mente meta metade mete mãe nem neta tem tema teme tenda tende tendem',
        extra: 'ade adem andem atem danem detê edema edta ema eme ementa ena ene enta eta manete meda mena mene menta nade ámen éden',
    },
    {
        letters: 'gronaid',
        words: 'agir ando ano dano dar daí dia diga digo dona dor droga dão dói gado gira girando giro ido indo irá irão não onda ora raio rio roda rádio',
        extra: 'adi adir ado adro agi agido agindo agro aio andor anidro argo aro digna digno dina dinar dirá dirão doa doar donga dora doía drago dória gaio gari garo gia gio gir girado girão goa gora gorda grado grã grão iago ida ignora inda ingo ingá ino ioga irado iro nadir nado nagi nagô nai nair nardo noa noda noia noir nora odiar odiá orai orgia ori rango raí ria rida rido rigo rina rindo rino roa roga rogai ronda rói ágio árido íon',
    },
    {
        letters: 'sdgaalo',
        words: 'algo alô aos das dos dão gado galo gol gols gás lado lados lago lagoa lagoas lagos las los olá saga sal sala saldo salgado salão sol são',
        extra: 'ada ado ala alado alados alas alga algas asa aso dala doa dol gados gala galas galos galão glosa goa gola golas lada lao laos loa loas loga olga sada sado saldão salga soa sola solda',
    },
    {
        letters: 'soesepn',
        words: 'esse nesse nos pense penso pensões peso pesos posse pés pós põe senso sons',
        extra: 'ene enes neo noé penses pensos pese peões pões seno sepse soe sopé ões',
    },
    {
        letters: 'sxciota',
        words: 'aos ato atos aço cai caio cais caos caso cia cita coisa costa cota cotas coxa cão isto saco sai saio são taco tais tia tio toca táxi tóxicas',
        extra: 'aio ais asco asi aso ati aços casto cati cato caxito cias cio cis cisa cisto cisão citas cito cosa cosi cosia cotia coxas csi cós ias ica icó isca isco ista ita oca ocas ois oiça ota oti otis saci sati sax sia sica sio sita sito sião soa soca sta sócia tai tas tias tica tico tios tião toa tocas tos tosa tosca táxis tóxica xai xica xico xis xisto xota ático ótica óticas',
    },
    {
        letters: 'tsabdiu',
        words: 'bati budista das daí dia dias dita ditas duas idas sai saiu situa sua sub suba subida sutiã súbita tabu tais tia tida tua tuas usa',
        extra: 'abi adi adis ais asi ati atu badi baú baús bida bidu bis bisa bita bua budas butiá dista diu dua dúbia dúbias ias iba ida ista ita itau sadi sati sia siba sita situ sta subi subia sui tabus tai tas tau tias tiba tidas tuba tubas uai ubi ubá uda udi',
    },
    {
        letters: 'arealiv',
        words: 'areia ela era eva irá lar lava lavar lei leia ler leva levar levaria livre raiva real rei rival vai vale valer valeria vela ver via vila vir vira área',
        extra: 'aia aie aire ala alar alia aliar alie alva areal aria arie arável ava aval avalie avaré ave aveia avelar avelã avia eia eira elvira erva erval iara ila ilê iva laia lari larva lave lavei lavra leiva leria lerá levai levará lia lira livra raia rala ralei rali ralé rava raí rela reli relva revi ria rial vaia vaiar vala valar valerá vali valia var vara varal varela vari varia varie vei veia velar veria verá viela vier viera vil vilar vire ávila',
    },
];